export default "__VITE_ASSET__BRIsmHO9__"